export function PostToStudentCard() {
	return <img alt='post to students' src='https://esgiwebfiles.s3.amazonaws.com/assignments-introduction/post-to-students.png' width='213'/>;
}